<template>
	<div class="job-vita--section">
		<div class="job-vita--section-title">{{ freetextData.title }}</div>
		<div class="pl-3 pl-md-5 pb-4">{{ freetextData.text }}</div>
	</div>
</template>

<script>
export default {

	props: {
		freetextData: {
			type: Object,
			required: true,
		}
	}
}
</script>
